import { Grid, Heading } from '@design-systems/canvas-ui'
import TeamsTabs from 'teams/components/TeamsTabs'
import UsersSearchBody from './UsersSearchBody'
import TeamsHeaderButtons from 'teams/components/TeamsHeaderButtons'
import { PaginationProvider } from '@plm-core/utils'
import { CoreSortAndFilterProvider } from '@plm-core/sort-and-filter'

const UsersSearchList = () => {
  return (
    <Grid.Container direction="column">
      <Grid.Item>
        <Grid.Container className="hc8-mb-6x" align="center">
          <Grid.Item size={{ xs: true }}>
            <Heading>Users</Heading>
          </Grid.Item>
          <Grid.Item>
            <TeamsHeaderButtons />
          </Grid.Item>
        </Grid.Container>
      </Grid.Item>
      <Grid.Item>
        <TeamsTabs />
      </Grid.Item>
      <Grid.Item>
        <CoreSortAndFilterProvider cacheKey="plm-users-list">
          <PaginationProvider>
            <UsersSearchBody />
          </PaginationProvider>
        </CoreSortAndFilterProvider>
      </Grid.Item>
    </Grid.Container>
  )
}

export default UsersSearchList
